<template>
  <aside :show.sync="show" placement="right" header="发布团队" :width="800">
    <form>
      <h4 class="text-center">【{{route.catalog}}】{{route.heading }}</h4>
      <div class="form-group">
        <label for="name" class="control-label">1. 选择团期</label>
        <d-calendar :dates.sync="dates"></d-calendar>
      </div>
      <div class="form-group">
        <label for="name" class="control-label">2. 选择集合地点&人数</label>
         <table class="table table-bordered">
          <tr>
            <th>#</th>
            <th v-for="item in times">{{item.assembleTime}}</th>
          </tr>
          <tr v-for="item in assemble">
            <th>{{item.assemblePlace}}</th>
            <th v-for="time in item.times" track-by="$index">
              <input type="text" class="form-control" v-model="time.size">
            </th>
          </tr>
        </table>
      </div>

      <div class="form-group">
        <label for="f2" class="control-label">3. 招募管理</label>
        <div>
          <span class="checkbox-inline" v-for="item in roles" track-by="$index">
            <label>
              <input type="checkbox" v-model="form.need" :value="item">{{item.role}}
            </label>
            <input
              type="number"
              class="form-control l-inline"
              v-model="item.size"
              placeholder="数">
          </span>
        </div>
      </div>

      <div class="form-group">
        <label class="control-label">抢单时间</label>
        <!-- <input type="datetime" data-field="datetime" v-model="form.openTime" /> -->

        <input v-model="form.openTime" type="datetime-local" @change="form.openTime = form.openTime.replace('T', ' ')"></input>{{form.openTime}}
      </div>

      <div class="form-group">
        <label class="control-label">抢单备注</label>
        <textarea id="" cols="30" rows="3" class="form-control" v-model="form.leaderTips"></textarea>
      </div>

      <div class="form-group">
        <label for="f2" class="control-label">4. 发送消息</label>
        <div>
          <label class="radio-inline">
            <input type="radio" v-model="form.messageLevel" :value="5">立即发送
          </label>
          <label class="radio-inline">
            <input type="radio" v-model="form.messageLevel" :value="0">稍后发送
          </label>
        </div>
      </div>
      <div class="form-group">
        <label for="f2" class="control-label">5. 是否显示</label>
        <div>
          <label class="radio-inline">
            <input type="radio" v-model="form.isShow" :value="1">显示
          </label>
          <label class="radio-inline">
            <input type="radio" v-model="form.isShow" :value="0">隐藏
          </label>
     </div>
      </div>
      <div class="form-group">
        <label for="f2" class="control-label">6. 是否定制团</label>
        <div>
          <label class="radio-inline">
            <input type="radio" v-model="form.isCustom" :value="1">定制团
          </label>
          <label class="radio-inline">
            <input type="radio" v-model="form.isCustom" :value="0">非定制
          </label>
        </div>
      </div>
      <div class="form-group">
        <label for="f2" class="control-label">7. 带队人员（领队 or 志愿者）</label>
        <div>
          <label class="radio-inline">
            <input type="radio" v-model="form.leaderRole" value="GIVER">领队
          </label>
          <label class="radio-inline">
            <input type="radio" v-model="form.leaderRole" value="ST_VOLUNTEER">ST志愿者
          </label>
          <label class="radio-inline">
            <input type="radio" v-model="form.leaderRole" value="CE_VOLUNTEER">CE志愿者
          </label>
        </div>
      </div>
      <div class="from-group text-center">
        <button class="btn btn-primary" type="button" @click="click(create)($event)">创建</button>
      </div>
    </form>
  </aside>
</template>

<script>
  import { aside } from 'vue-strap'
  import dCalendar from '../../components/DCalendar'
  import utils from '../../libs/utils'
  import config from '../../libs/config'
  import _ from 'lodash'

  let form = {
    leaderTips: '',
    need: [],
    stopTime: '',
    openTime: null,
    messageLevel: 0,
    isShow: 1,
    isCustom: 0,
    leaderRole: 'GIVER'
  }
  let roles = [
    {
      role: '领队',
      size: ''
    },
    {
      role: 'ST志愿者',
      size: ''
    },
    {
      role: '督导',
      size: ''
    },
    {
      role: '试走',
      size: ''
    },
    {
      role: '考官',
      size: ''
    },
    {
      role: 'CE大活动志愿者',
      size: ''
    }
  ]

  export default {
    components: {
      aside,
      dCalendar
    },
    props: {
      route: {
        required: true,
        type: Object
      },
      show: {
        required: true,
        twoWay: true
      }
    },
    data () {
      return {
        dates: [],
        assemble: [],
        places: [],
        times: [],
        form: Object.assign({}, form),
        roles: roles
      }
    },
    methods: {
      create () {
        let trips = []
        if (!this.dates.length) {
          window.alert('请选择日期')
          return Promise.reject()
        }
        this.dates.forEach((date) => {
          this.assemble.forEach(({assemblePlace, times}) => {
            times.forEach(({assembleTime, size, assemblePeriod}) => {
              if (size) {
                let need = _.cloneDeep(this.form.need)
                need.map(item => {
                  item.openTime = this.form.openTime ? this.form.openTime.replace('T', ' ') : ''
                })
                // let leader = _.find(need, ['role', '领队'])
                // if (leader) {
                //   // leader.size = Math.round(size / 10)
                //   leader.size = 1
                // }
                let trip = Object.assign({}, this.form, {
                  start: date,
                  assemblePlace,
                  assembleTime,
                  assemblePeriod,
                  size,
                  need
                })
                trips.push(trip)
              }
            })
          })
        })
        let data = {
          routeId: this.route.id,
          trips
        }
        return this.$http.post(`${config.apiWe}/product/trip`, data)
          .then(() => {
            this.show = false
          })
      },
      click: utils.click
    },
    watch: {
      route (val) {
        let places = val.assemblePlace
        let times = val.assembleTime
        let assemble = places.map(({detail}) => {
          return {
            assemblePlace: detail,
            times: times.map(({assembleTime, assemblePeriod}) => {
              return {
                assembleTime,
                assemblePeriod,
                size: ''
              }
            })
          }
        })
        this.$set('assemble', assemble)
        this.$set('places', places)
        this.$set('times', times)
      }
    }
  }
</script>
<style scoped>
  .d-control-label {
    margin-top: 5px;
  }
  .l-inline {
    display: inline-block;
    width: 4em;
  }
</style>



/** WEBPACK FOOTER **
 ** CreateTrip.vue?901d3358
 **/